import { Component, Vue } from 'vue-property-decorator';
import { SelectOption } from '@/types/types';
import { VesselFields } from '@/types/graphql/schemaTypes';

// gql
import vesselsSearchQuery from '@/graphql/queries/VesselsSearch.gql';

@Component({
  apollo: {
    vesselsOptions: {
      query: vesselsSearchQuery,
      debounce: 300,
      prefetch: true,
      variables() {
        return { name: this.searchVesselString };
      },
      update(data): SelectOption<VesselFields>[] {
        return data.vessels.map(this.formatVesselsOptions);
      }
    }
  }
})

export default class VesselOptionsMixin extends Vue {
  public vesselsOptions: SelectOption<VesselFields>[] = [];
  public searchVesselString = '';

  public formatVesselsOptions(vessel: VesselFields): SelectOption<VesselFields> {
    return {
      label: vessel.name,
      value: vessel
    };
  }

  public updateVesselOptions() {
    this.$apollo.queries.vesselsOptions.refetch();
  }
}
